import styled from "styled-components";

import { breakpoints } from "@/styles/breakpoints";

export const StyledConversationThumbnail = styled.img<{ $pdfThumbnail: boolean }>`
    flex-shrink: 0;
    width: 88px;
    min-width: 88px;
    height: 88px;
    min-height: 88px;
    border-radius: 8px;
    object-fit: cover;
    ${(props) =>
        props.$pdfThumbnail &&
        `
        width: 450px;
        min-width: 450px;
        @media ${breakpoints.xs} {
            width: 250px;
            min-width: 250px;
        }
        `}
`;

export const StyledConversationThumbnailDescription = styled.span`
    position: absolute;
    right: 4px;
    bottom: 0;
    left: 0;
    display: block;
    padding: 7px 8px;
    overflow: hidden;
    font-size: var(--size-12);
    line-height: 18px;
    color: var(--color-white);
    text-overflow: ellipsis;
    white-space: nowrap;
    background: var(--color-grey-900);
    border-bottom-right-radius: 8px;
    border-bottom-left-radius: 8px;
    opacity: 0.8;
`;
